export default {
  hero: {
    title: 'Tin Tức & Bài Viết',
    subtitle: 'Cập nhật thông tin mới nhất về định cư Latvia, xuất nhập khẩu và Asian Alley',
  },
  featured: 'Bài Viết Nổi Bật',
  allArticles: 'Tất Cả Bài Viết',
  categories: {
    all: 'Tất Cả',
    latvia: 'Định Cư Latvia',
    export: 'Xuất Nhập Khẩu',
    asianAlley: 'Asian Alley',
    guide: 'Hướng Dẫn',
  },
  empty: {
    title: 'Không tìm thấy bài viết nào',
    description: 'Hãy thử chọn danh mục khác hoặc quay lại sau.',
  },
  readMore: 'Đọc Thêm',
  minuteRead: 'phút đọc',
  cta: {
    title: 'Cần Tư Vấn Về Định Cư Latvia?',
    description: 'Đội ngũ chuyên gia của chúng tôi sẵn sàng giải đáp mọi thắc mắc',
    button: 'Đăng Ký Tư Vấn',
  },
  detail: {
    backToList: 'Quay Lại Danh Sách',
    share: 'Chia Sẻ',
    relatedPosts: 'Bài Viết Liên Quan',
    tableOfContents: 'Mục Lục',
  },
} as const;